<template>
  <b-card>
    <iframe
      v-if="iframeUrl !== null"
      :src="
        `${iframeUrl}`
      "
      id="i-frame"
      width="100%"
      height="800"
      frameborder="0"
      crossorigin
    >
    </iframe>
  </b-card>
</template>

<script>
import {  
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import appsettings from "@/store/app-settings";

export default {
  
  components: {
    BCard,
  BCardHeader,
  BCardBody,
  },
  props: {
    iframeUrl: null
  },
  data() {
    
  },  
  methods: {
    
  },
};
</script>

<style></style>
